module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "htmlAndCss"
  }, [_c('blockHeader', {
    attrs: {
      "val": _vm.headerText
    }
  }), _vm._v(" "), _c('contentEl', {
    attrs: {
      "db": _vm.dbPost
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08794c7a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/htmlAndCssContent.vue
// module id = 65
// module chunks = 0